import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from './endpoints';
import { ExternalUrlGroupsItemWire } from './types';
import { OptionsRequestParams } from 'app/infrastructure/ui/form/types';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadExternalUrlOptions: async (query: string, optionsRequestParams: OptionsRequestParams): Promise<Value[]> => {
    const response = await new RemoteAdminData(query
      ? `${endpoints.externalUrlOptions}/search`
      : endpoints.externalUrlOptions)
      .resource<ApiResponse<Value[]>>()
      .filter(optionsRequestParams).all();

    return response.data;
  },

  loadExternalUrlGroup: async (id: number): Promise<ExternalUrlGroupsItemWire> => {
    const response = await new RemoteAdminData(endpoints.externalUrlGroupItem)
      .resource<ApiResponse<ExternalUrlGroupsItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },

  deleteExternalUrlGroup: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.externalUrlGroupItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  addExternalUrlGroup: async (externalUrl: ExternalUrlGroupsItemWire): Promise<number> => {
    const response: any = await new RemoteAdminData(endpoints.externalUrlGroupItem)
      .resource<ApiResponse<number>>()
      .create(externalUrl, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },

  updateExternalUrlGroup: async (id: number, externalUrl: ExternalUrlGroupsItemWire): Promise<number> => {
    await new RemoteAdminData(endpoints.externalUrlGroupItem)
      .resource<void>()
      .withId(id)
      .save(externalUrl);

    return id;
  }
};
